<template>
	<div style="background: #f2f2f2;">
		<common-head active="0" state="1" @search="search"></common-head>


		<common-footer></common-footer>
	</div>
</template>

<script>

	import commonHead from '@/components/wap/commonHead.vue';
	import commonFooter from '@/components/wap/commonFooter.vue';
	import { product_list } from '@/api/product.js';

	export default {
		name: 'search',
		components: {
			commonHead, commonFooter
		},
		data() {
			return {
				keyword:'',
			}
		},
		created () {
			this.keyword = this.$route.query.keyword;
		},
		metaInfo() {
			return {
				title: '搜索列表' + '-' + this.config.site.name,
				meta: [
					{ name: "keywords", content: "" },
					{ name: "description", content: "" },
					{ name: 'viewport', content:'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'}
				],
			}
		},
		methods: {
			search(keyword){
				this.keywod = keyword;
				this.$refs.case.get_list(0,keyword);
				const newUrl = this.$route.path + `?keyword=${keyword}`;
				window.history.replaceState('', '', newUrl);	
			},
		},
	}
</script>
<style scoped>

</style>